import PluginAction from '../PluginAction';
import * as Cart from 'rev.sdk.js/Actions/Cart';

export default class onCartLoadedPlugin extends PluginAction {
  shouldExecute(...args) {
    return true;
  }

  executeSync(...args) {
    const [cart, checkoutFormSpec, defaultUser] = args;

    const hasCustomizedProduct = cart.items.some((item) => {
      return item.product.labels.indexOf('custom') >= 0;
    });
    const isCodDisabled = true;

    checkoutFormSpec.paymentSubTypes = [
      Cart.PAYMENT_SUBTYPE.credit,
      ...(hasCustomizedProduct || isCodDisabled
        ? []
        : [Cart.PAYMENT_SUBTYPE.cod]),
    ];
    checkoutFormSpec.logisticsTypes = [Cart.LOGISTICS_TYPE.cvs];
    checkoutFormSpec.logisticsSubTypes = {
      [Cart.LOGISTICS_TYPE.cvs]: [
        Cart.LOGISTICS_SUBTYPE.famic2c,
        Cart.LOGISTICS_SUBTYPE.hilifec2c,
        Cart.LOGISTICS_SUBTYPE.unimartc2c,
      ],
      [Cart.LOGISTICS_TYPE.home]: [],
    };
    checkoutFormSpec.invoiceCategories = [
      Cart.INVOICE_CATEGORY.b2c,
      Cart.INVOICE_CATEGORY.b2b,
    ];
    checkoutFormSpec.invoiceCarrierTypes = [
      Cart.INVOICE_CARRIER_TYPE.none,
      Cart.INVOICE_CARRIER_TYPE.ecpay,
      Cart.INVOICE_CARRIER_TYPE.cdc,
      Cart.INVOICE_CARRIER_TYPE.mobile,
    ];

    const updateConfig = {
      ...cart,
      ...defaultUser,
    };

    return {
      updateConfig,
      checkoutFormSpec,
    };
  }
}
